// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"ddcc9b35","584":"0003c961","606":"a1ed0701","688":"ddcc9b35"}[chunkId] + ".chunk.css";
};